import Hero from '../components/home/Hero';
import Seo from '../components/Seo';
import StatementSection from '../components/home/StatementSection';
import SplitFeature from '../components/home/SplitFeature';
import DesignManufacturing from '../components/home/DesignManufacturing';
import EngineeringHighlightsGrid from '../components/home/EngineeringHighlightsGrid';
import ProductsAndDesigns from '../components/home/ProductsAndDesigns';
import FeatureShowcaseGrid from '../components/home/FeatureShowcaseGrid';
import InsightsBanner from '../components/home/InsightsBanner';
import NewsSection from '../components/home/NewsSection';
import CareersCTA from '../components/home/CareersCTA';
import ClientsSection from '../components/home/ClientsSection';
import ContactForm from '../components/contacts/ContactForm';

function HomePage() {
  return (
    <>
      <Seo
        title="PVS Harness Solution | Wire Harness Manufacturer"
        description="Trusted manufacturer of durable, precise, cost-effective wire harness assemblies for automotive, electrical, and industrial sectors."
        path="/"
        schema={{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "PVS Harness Solution",
          "url": "https://pvsharness.com/",
          "logo": "https://pvsharness.com//logo.png",
          "description": "Manufacturer of wire harness assemblies for automotive, electrical, and industrial sectors."
        }}
      />

      <Hero />

      {/* Spacer - matches original gap between hero/cards and the statement section */}
      <div className="h-24 sm:h-40 lg:h-56 bg-gray-50" />

      <StatementSection />
      <SplitFeature />
      <DesignManufacturing />
      <EngineeringHighlightsGrid />
      <FeatureShowcaseGrid />
      <ProductsAndDesigns />

      <InsightsBanner />
      <ClientsSection/>
      <ContactForm/>

    </>
  );
}

export default HomePage;